module.exports = __webpack_public_path__ + "static/media/card-bg-strong.3b62a7f9.png";